import { render, staticRenderFns } from "./Viewer.vue?vue&type=template&id=4a826923&scoped=true"
import script from "./Viewer.vue?vue&type=script&lang=js"
export * from "./Viewer.vue?vue&type=script&lang=js"
import style0 from "./Viewer.vue?vue&type=style&index=0&id=4a826923&prod&lang=scss&scoped=true"
import style1 from "./Viewer.vue?vue&type=style&index=1&id=4a826923&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a826923",
  null
  
)

export default component.exports